import { render, staticRenderFns } from "./SoftwareDetails.vue?vue&type=template&id=6775ba77&scoped=true&"
import script from "./SoftwareDetails.vue?vue&type=script&lang=js&"
export * from "./SoftwareDetails.vue?vue&type=script&lang=js&"
import style0 from "./SoftwareDetails.vue?vue&type=style&index=0&id=6775ba77&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6775ba77",
  null
  
)

export default component.exports